/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTemperatureMinus: {
  name: 'temperature-minus';
  data: string;
} = {
  name: 'temperature-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.5a.5.5 0 0 0-.5.5v7a.503.503 0 0 1-.007.085.5.5 0 0 1-.326.556A2.501 2.501 0 0 0 10 14.5a2.5 2.5 0 0 0 .833-4.858.5.5 0 0 1-.326-.556A.506.506 0 0 1 10.5 9V2a.5.5 0 0 0-.5-.5Zm1.5 7.336V2a1.5 1.5 0 0 0-3 0v6.836a3.5 3.5 0 1 0 3 0ZM2.5 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></svg>`,
};
